import { useEffect, useState } from "react";
import { LockScreen } from "./LockScreen";

const API = process.env.REACT_APP_BACKEND_URL;
const KEY = "ordo-site-pass";

export const SiteGate = ({ children }) => {
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const token = window.localStorage.getItem(KEY);
    if (!token) {
      setStatus("locked");
      return;
    }
    fetch(`${API}/api/gate/verify`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => {
        if (!r.ok) window.localStorage.removeItem(KEY);
        setStatus(r.ok ? "open" : "locked");
      })
      .catch(() => setStatus("locked"));
  }, []);

  const unlock = (token) => {
    window.localStorage.setItem(KEY, token);
    setStatus("open");
  };

  if (status === "open") return children;
  if (status === "checking") return <div className="t-ink min-h-screen bg-o-bg" data-testid="gate-checking" />;
  return <LockScreen onUnlock={unlock} />;
};
